/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Global routes in web application are defined  here
 */
const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  LOGIN_REDIRECT: '/login-callback',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_CALLBACK: '/verify-callback',
  SIGN_UP: '/sign-up',
  DASHBOARD: '/dashboard',
  FORECAST_UPLOAD: '/dashboard/forecast-upload',
  RATE_CALENDAR: '/rate-calendar',
  CONFIGURE: '/configure',
  USERS: '/configure/users',
  EVENT_CATEGORIES: '/configure/event-categories',
  CONFIGURE_HOTELS: '/configure/hotels',
  NOT_FOUND: '*',
  USER_MANUAL: '/help',
  FAQ: '/faq',
  SUPPORT: '/support',
};
//
export default ROUTES;
